import store from './../store/store'
import Vue from 'vue'
import axios from 'axios'

let http = null
let defaultContentType = null

class HttpUtil {
  static clearhttp () {
    http = null
  }

  constructor (endpoint) {
    this.endpoint = endpoint
    if (http === null) {
      http = axios.create({
        baseURL: store.state.appSettings.apiurl,
        headers: HttpUtil.getHeaders()
      })
    }
  }

  get (data = null, resolve = null, reject = null) {
    return http.get(this.endpoint, {params: data})
      .then(response => {
        resolve && resolve(response)
      })
      .catch(error => {
        reject && reject(error)
      })
  }

  show (id, resolve = null, reject = null) {
    return http.get(this.endpoint + '/' + id)
      .then(response => {
        resolve && resolve(response)
      })
      .catch(error => {
        reject && reject(error)
      })
  }

  create (data, resolve, reject) {
    if (data instanceof FormData) {
      this.setMultipartContentType()
    }

    return http.post(this.endpoint, data)
      .then(response => {
        this.setApplicationJsonContentType()
        resolve && resolve(response)
      })
      .catch(error => {
        this.setApplicationJsonContentType()
        reject && reject(error)
      })
  }

  update (data, resolve, reject) {
    let id = null
    let method = 'put'

    if (data instanceof FormData) {
      data.append('_method', 'PUT')
      id = data.get('id')
      method = 'post'
      this.setMultipartContentType()
    } else {
      id = data.id
    }

    return http[method](this.endpoint + '/' + id, data)
      .then(response => {
        this.setApplicationJsonContentType()
        resolve && resolve(response)
      })
      .catch(error => {
        this.setApplicationJsonContentType()
        reject && reject(error)
      })
      .then(() => {
        this.setApplicationJsonContentType()
      })
  }

  delete (id, resolve, reject) {
    return http.delete(this.endpoint + '/' + id)
      .then(response => {
        resolve && resolve(response)
      })
      .catch(error => {
        reject && reject(error)
      })
  }

  setMultipartContentType () {
    defaultContentType = http.defaults.headers['Content-Type']
    http.defaults.headers['Content-Type'] = 'multipart/form-data'
  }

  setApplicationJsonContentType () {
    http.defaults.headers['Content-Type'] = defaultContentType || 'application/json;charset=UTF-8'
  }

  getInstance () {
    return http
  }

  static getStaticInstance () {
    return http
  }

  getNewInstance () {
    return axios.create({
      baseURL: store.state.appSettings.apiurl,
      headers: HttpUtil.getHeaders()
    })
  }

  static resetInstance () {
    http = null
  }

  static getHeaders () {
    return {
      Accept: 'application/json',
      Authorization: 'Bearer ' + Vue.ls.get('token', '')
    }
  }
}

export default HttpUtil



// WEBPACK FOOTER //
// ./src/util/HttpUtil.js